import { useEffect, useState } from "react";
import styles from "./MainLayout.module.scss";
import { Link, Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar/Sidebar";
import defaultUser from "../assets/images/Profile.png";
import SearchIcon from "../assets/images/svgs/SearchIcon";
import Notification from "../assets/images/svgs/Notification";
import MenuIcon from "../assets/images/svgs/MenuIcon";
import CurrencyDropdown from "../components/currency-dropdown/CurrencyDropdown";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../context/NotificationContext";
import ProfileService from "../api/services/profile.service";

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState<string | null>(null);
  const navigate = useNavigate();
  const { buttons, searchValue, setSearchValue } = useAuth();
  const { unreadCount } = useNotifications();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await ProfileService.getProfile();
        setProfilePhoto(res.data?.profile_photo || null);
      } catch (e) {
        setProfilePhoto(null);
      }
    };
    fetchProfile();
  }, []);

  return (
    <div className={styles.layout}>
      <Sidebar
        open={sidebarOpen}
        setOpen={setSidebarOpen}
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
      />

      <header
        className={`${styles.header} ${
          sidebarCollapsed ? styles.collapsed : ""
        }`}
      >
        <button className={styles.menuBtn} onClick={() => setSidebarOpen(true)}>
          <MenuIcon />
        </button>
        <div className={styles.left}>
          <div className={styles.input_wrapper}>
            <div className={styles.search}>
              <SearchIcon />
            </div>
            <input
              type="text"
              placeholder="Search here..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
        </div>

        {buttons.length > 0 ? (
          <div className={styles.action_btns}>{buttons}</div>
        ) : null}

        <div className={styles.actions}>
          <CurrencyDropdown />
          <div
            onClick={() => navigate("notifications")}
            className={styles.notificationWrapper}
          >
            <Notification />
            {unreadCount > 0 && (
              <div className={styles.badge}>
                {unreadCount > 99 ? "99+" : unreadCount}
              </div>
            )}
          </div>
          <Link to="/dashboard/info" className={styles.user}>
            <img src={profilePhoto || defaultUser} alt="" />
          </Link>
        </div>
      </header>
      {buttons.length > 0 ? (
        <div className={styles.mobile_action_btns}>{buttons}</div>
      ) : null}
      <div
        className={`${styles.outlet} ${
          sidebarCollapsed ? styles.collapsed : ""
        }`}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
